export enum Products {
  ViewPlus = 'view-plus',
  WaveEnhance = 'wave-enhance',
  Renew = 'renew',
  ViewRadon = 'view-radon',
  WaveMini = 'wave-mini',
}

type Product = {
  analyticsKey: string;
  color: string;
  imageUrl: string;
  shopUrl: string;
  slug: Products;
  translationKey: string;
};

const PRODUCTS: ReadonlyArray<Product> = [
  {
    analyticsKey: 'view_plus',
    color: 'var(--view-plus-main)',
    imageUrl: '/images/view-plus.png',
    shopUrl: 'view-plus',
    slug: Products.ViewPlus,
    translationKey: 'ProductViewPlus',
  },
  {
    analyticsKey: 'wave_enhance',
    color: 'var(--wave-enhance-main)',
    imageUrl: '/images/wave-enhance.png',
    shopUrl: 'wave-enhance',
    slug: Products.WaveEnhance,
    translationKey: 'ProductWaveEnhance',
  },
  {
    analyticsKey: 'renew',
    color: 'var(--renew-main)',
    imageUrl: '/images/renew.png',
    shopUrl: 'renew',
    slug: Products.Renew,
    translationKey: 'ProductRenew',
  },
  {
    analyticsKey: 'view_radon',
    color: 'var(--view-radon-main)',
    imageUrl: '/images/view-radon.png',
    shopUrl: 'view-radon',
    slug: Products.ViewRadon,
    translationKey: 'ProductViewRadon',
  },
  {
    analyticsKey: 'wave_mini',
    color: 'var(--wave-mini-main)',
    imageUrl: '/images/wave-mini.png',
    shopUrl: 'wave-mini',
    slug: Products.WaveMini,
    translationKey: 'ProductWaveMini',
  },
] as const;

export type ProductData = Product & {
  next?: Products;
  previous?: Products;
};

const getNext = (products: readonly Product[], index: number): Products =>
  products[index + 1 < products.length ? index + 1 : 0].slug;

const getPrevious = (products: readonly Product[], index: number): Products =>
  products[index !== 0 ? index - 1 : products.length - 1].slug;

const PRODUCTS_BY_SLUGS = Object.fromEntries(
  PRODUCTS.map((product, index, products) => [
    product.slug,
    Object.assign({}, product, {
      next: getNext(products, index),
      previous: getPrevious(products, index),
    }),
  ])
) as Record<Products, ProductData>;

export const getProduct = (slug?: string): ProductData | null =>
  slug ? PRODUCTS_BY_SLUGS[slug as Products] : null;
